// Search params of the partner list (Master data → Partners; role: the
// Customers / Suppliers view, ADR-046). Kept apart from the page
// component: route config (validateSearch) stays in the entry chunk, so
// anything it imports would be pulled out of the lazily loaded route chunk.

import { partnerListColumns } from "@patronix/domain/list";
import { viewSearch, type ViewSearch } from "@/lib/listView";

export interface PartnerSearch extends ViewSearch {
  q: string;
  inactive: boolean;
  /** Customers or suppliers only; absent = every partner. */
  role?: "customer" | "supplier" | undefined;
  partner?: string | undefined;
  /** The import panel is open (replaces the partner detail). */
  import?: "partners" | undefined;
}

export function validatePartnerSearch(raw: Record<string, unknown>): PartnerSearch {
  const s: PartnerSearch = {
    q: typeof raw.q === "string" ? raw.q.slice(0, 100) : "",
    inactive: raw.inactive === true || raw.inactive === "true",
  };
  if (typeof raw.partner === "string" && raw.partner && raw.partner.length <= 64) s.partner = raw.partner;
  if (raw.import === "partners") s.import = raw.import;
  if (raw.role === "customer" || raw.role === "supplier") s.role = raw.role;
  return { ...s, ...viewSearch(partnerListColumns, raw) };
}
